import {combineReducers} from 'redux';
import {persistReducer} from 'redux-persist';
import storage from '@react-native-async-storage/async-storage';
import modal from './Modal';
import user from './User';
import vehicle from './vehicle';
import start from './Start';
import reserve from './Reserve';
import signmodal from './SignModal';
import mypackages from './Packages';
import config from './Config';
import notice from './notificatios';
import vehiclesList from './VehiclesList';
import alert from './AlertReducer';
import rootModal from './ModalReducer';
import map from './map';
import url from './Url';
import deepLink from './DeepLink';
import internalClock from './InternalClockReducer';
import app from './AppReducer';
import {LOGOUT_ACTION} from '../actions/types';
import SheetReducer from './SheetReducer';
import learnReducer from './learnReducer';
const persistConfig = {
  key: 'root',
  storage,
  whitelist: [
    'user',
    'start',
    'vehicle',
    'mypackages',
    'config',
    'vehiclesList',
    'map',
    'url',
    'learn', 
  ],
  blacklist: [
    'signmodal',
    'notice',
    'modal',
    'deepLink',
    'alert',
    'internalClock',
    'app',
    'rootModal',
    'SheetReducer',
    
  ],
};

const appReducers = combineReducers({
  modal,
  user,
  vehicle,
  start,
  reserve,
  signmodal,
  mypackages,
  config,
  notice,
  vehiclesList,
  map,
  url,
  deepLink,
  alert,
  internalClock,
  app,
  rootModal,
  SheetReducer,
learn: learnReducer, 
  
});

const rootReducer = (state, action) => {
  if (action.type === LOGOUT_ACTION) {
    Object.keys(state).forEach(key => {
      key != 'url' || 'config' ? storage.removeItem(`persist:${key}`) : null;
    });
    const {url, config} = state;
    state = {config, url};
  }
  return appReducers(state, action);
};

export default persistReducer(persistConfig, rootReducer);
